import {all} from 'redux-saga/effects';
import auth, {authSaga} from './auth';
import loading from './loading';
import dashboard, {dashboardSaga} from './admin/dashboard';
import database, {databaseSaga} from './admin/database';
import docs, {docsSaga} from './admin/docs';
import adminFeedback, {adminFeedbackSaga} from './admin/feedback';
import faq, {faqSaga} from './admin/faq';
import voca, {vocaSaga} from './admin/voca';
import chat, {chatSaga} from './chat/chat';
import download, {downloadSaga} from './chat/download';
import feedback, {feedbackSaga} from './chat/feedback';
import idea, {ideaSaga} from './idea/idea';

const rootReducer = {
    auth,
    loading,
    dashboard,
    database,
    docs,
    adminFeedback,
    faq,
    voca,
    chat,
    download,
    feedback,
    idea
};

export function* rootSaga() {
    yield all([authSaga(), dashboardSaga(), databaseSaga(), docsSaga(), adminFeedbackSaga(), faqSaga(), vocaSaga(), chatSaga(), downloadSaga(), feedbackSaga(), ideaSaga()]);
}

export default rootReducer;
